import { useDispatch } from 'react-redux';
import { useUserInputsApiFacade } from '../../../../apis/facades/useUserInputsApiFacade';
import { useEffect, useState } from 'react';
import {
  generateTagsAndUsersSummary,
  setUserInputsByConfigurationId,
} from '../../../../reducers/documentation/userInputsReducer';

export const useInitializeUserInputs = (crmOrgId: string) => {
  const { get_userInputsForOrg } = useUserInputsApiFacade();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      const userInputs = await get_userInputsForOrg({ crmOrgId });
      dispatch(setUserInputsByConfigurationId({ userInputs }));
      dispatch(generateTagsAndUsersSummary({ crmOrgId }));
      setIsLoading(false);
    })();
  }, [crmOrgId, get_userInputsForOrg, dispatch]);

  return isLoading;
};
